"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isService = void 0;
function isService(service) {
    return service !== null && typeof service === "object";
}
exports.isService = isService;
//# sourceMappingURL=isService.js.map